import { render, staticRenderFns } from "./InvoiceDashboard.vue?vue&type=template&id=b071159e&"
import script from "./InvoiceDashboard.vue?vue&type=script&lang=js&"
export * from "./InvoiceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports